export const api = {
  visitorSubscribe: '/biz/visit/showPageList', // 访客预约记录
  showVisit: '/biz/visit/showVisit', // 访客详情
  examineVisit: '/biz/visit/examineVisit', // 访客审批操作
}